import { render } from "./issue.vue?vue&type=template&id=19022c46&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"

import "./issue.vue?vue&type=style&index=0&id=19022c46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19022c46"

export default script